export default function (app) {
  app.factory('klTranslationService', [
    '$q',
    '$http',
    '$translate',
    'klLocalStorageService',
    function ($q, $http, $translate, LocalStorageService) {
      let locale = LocalStorageService.get('locale');
      if (!!locale) $translate.use(locale);

      function getLanguage() {
        return $translate.use();
      }

      function setLanguage(locale) {
        LocalStorageService.set('locale', locale);
        $translate.use(locale);
      }

      return {
        getLanguage,
        setLanguage,
      };
    },
  ]);
}
